import { Col, Flex, Tooltip, Typography } from "antd";
import { ColumnType } from "antd/es/table";

import {
  REVERSE_ORDER_MAP,
  COMPANY_STATUSES,
  UserCompanyGridDto,
  COMPANY_ROLES,
  CompanyRole,
  UserListEntity,
} from "interfaces";
import { UserCompanyList } from "stores/UserCompanyList";
import { Status } from "ui";
import { dateFormat, getSortIcon } from "utils";
import { RemoveCompanyFromUserButton } from "./RemoveCompanyFromUserButton";
import { UserRoleList } from "components";
import { UserStore } from "stores/UserStore";

import styles from "./companyList.module.css";

export const getColumns = (companyList: UserCompanyList, user: UserStore, userInfo: UserListEntity) => {
  const { isUserAdmin } = user.roles;

  return [
    {
      title: "Название компании",
      dataIndex: "companyName",
      key: "companyName",
      width: 210,
      className: `text-clamp-ellipsis ${styles.companyName}`,
      render: (companyName: string) => (
        <Tooltip trigger="hover" placement="topLeft" title={companyName}>
          <span>{companyName}</span>
        </Tooltip>
      ),
    },
    {
      dataIndex: "companyRegistrationNumber",
      key: "companyRegistrationNumber",
      title: "ОГРН/ОГРНИП",
      width: 133,
    },
    {
      dataIndex: "inn",
      key: "inn",
      title: "ИНН",
      width: 110,
    },
    {
      dataIndex: "type",
      key: "type",
      title: "Тип компании",
      width: 200,
      render: (role: CompanyRole) => COMPANY_ROLES.texts[role],
    },
    {
      dataIndex: "role",
      key: "roles",
      title: "Роль пользователя",
      width: 200,
      render: (_: any, record: UserCompanyGridDto) => {
        return (
          <UserRoleList
            roles={record.roles}
            companyInfo={{
              companyName: record.companyName,
              companyRegistrationNumber: record.companyRegistrationNumber,
              id: record.id,
              role: record.type,
            }}
            userInfo={userInfo}
          />
        );
      },
    },
    {
      dataIndex: "company.statusDate",
      key: "statuses",
      title: "Статус",
      sorter: { multiple: 2 },
      sortOrder: companyList.sorters?.statusDate ? REVERSE_ORDER_MAP[companyList.sorters?.statusDate] : undefined,
      sortIcon: getSortIcon,
      width: 180,
      render: (_: any, record: UserCompanyGridDto) => {
        return (
          <Flex vertical>
            <Col>
              <Status color={COMPANY_STATUSES.colors[record.status]} children={COMPANY_STATUSES.texts[record.status]} />
            </Col>
            <Typography.Text type="secondary">{dateFormat(record.statusDate, true)}</Typography.Text>
          </Flex>
        );
      },
    },
    companyList.allData.length > 1 &&
      isUserAdmin && {
        dataIndex: "id",
        key: "remove",
        align: "right",
        width: 20,
        render: (id: string) => {
          return <RemoveCompanyFromUserButton companyId={id} />;
        },
      },
  ].filter((c) => !!c) as ColumnType<UserCompanyGridDto>[];
};
